import { ApiError } from '../../api';

/** The pt-BR note shown next to a field the server rejected. */
export const FIELD_REJECTED = 'Confira este campo.';

/**
 * Which fields the server rejected, keyed by the last segment of the dotted
 * path it returned (`body.date_of_birth` becomes `date_of_birth`).
 *
 * The server's own wording is not carried across. Pydantic writes its
 * validation messages in English, for whoever is integrating, and putting them
 * on a form would leave one sentence on the screen in the wrong language. The
 * useful part of `details` is machine-readable -- which field -- and that is
 * what this extracts. The original text stays on the `ApiError` for debugging.
 */
export function fieldErrors(error: unknown): Record<string, string> {
  if (!(error instanceof ApiError)) {
    return {};
  }
  const byField: Record<string, string> = {};
  for (const detail of error.details) {
    if (detail.field === null || detail.field === undefined) {
      continue;
    }
    const segments = detail.field.split('.');
    const name = segments[segments.length - 1];
    if (name !== undefined && !(name in byField)) {
      byField[name] = FIELD_REJECTED;
    }
  }
  return byField;
}
